import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Reaction, ReactionId, Reactions, RichTextComment, Thread, Threads, TimelineItem, TimelineItemType } from '@teammood/timeline';
import { EMOTICON_REACTION_DEFS, EmoticonReaction } from './emoticon-reactions/emoticon-reaction.type';
import { Time } from 'highcharts';
import { Task } from 'app/frontend/lib/taskbook-triage/taskbook.types';

@Injectable({
  providedIn: 'root'
})
export class ReactionService {

  constructor(private httpClient: HttpClient) { }
  
  async react(itemId: string, itemType: string, reaction: ReactionId): Promise<{id: string, itemType: TimelineItemType} & Reactions> {
    return await firstValueFrom(this.httpClient.put<{id: string, itemType: TimelineItemType} & Reactions>('/api/timeline/' + itemType + '/' + itemId + '/reaction/', {reaction: reaction}));
  }

  async reactToThread(timelineItemId: string, itemType: string, threadId: string, reaction: ReactionId): Promise<TimelineItem & Threads> {
    return await firstValueFrom(this.httpClient.put<TimelineItem & Threads>('/api/timeline/' + itemType + '/' + timelineItemId + '/thread/' + threadId + '/reaction/', {reaction: reaction}));
  }

  async reactToTaskThread(taskItemId: string, itemType: string, threadId: string, reaction: ReactionId): Promise<Threads> {
    return await firstValueFrom(this.httpClient.put<Threads>('/api/timeline/' + itemType + '/' + taskItemId + '/thread/' + threadId + '/reaction/', {reaction: reaction}));
  }

  mapToEmoticonReactions(reactions: Reaction[]): EmoticonReaction[]{
    return reactions
      .map(reaction => {
        const reactionDef = EMOTICON_REACTION_DEFS.get(reaction.id);
  
        // if no definition found, throw error
        if (!reactionDef) {
          return undefined;
        }
  
        return { ...reactionDef, ...reaction };
      }).filter(reaction => !!reaction);
  }
}